import { IsString } from 'class-validator';

export class OverrideEmailRequestDto {
  @IsString()
  email!: string;

  @IsString()
  providerName!: string;
}
